
import debounce from 'lodash.debounce';
import Btn from "./Btn";
import {mapMutations} from "vuex";
export default {
    components: {Btn},
    props: ["product", "editMode", "showMainSkipStatus"],
    data() {
        return {
            showSizes: false,
            error: null,
            process: false,
            success: false,
        }
    },
    computed: {
        priceFormated() {
            return new Intl.NumberFormat('ru-RU').format(this.product.price);
        },
        priceBaseFormated() {
            return new Intl.NumberFormat('ru-RU').format(this.product.price_base);
        },
    },
    mounted() {
    },
    watch: {
        'product.main_rating'(newValue){
            this.debouncedUpdateMainRating(newValue);
        }
    },
    created() {
        this.debouncedUpdateMainRating = debounce(this.changeMainRating, 500);
    },
    methods: {
        ...mapMutations({
            setBasketCount: 'setBasketCount',
        }),

        changeMainSkip(){
            this.$emit('change-main-skip', this.product.id);
        },

        changeMainRating(){
            this.$emit('change-main-rating', this.product.id, this.product.main_rating);
        },

        buy(){
            if(this.product.has_sizes){
                this.showSizes = true;
                return;
            }
            this.buyProduct(null);
        },

        buySize(size){
            this.buyProduct(size);
        },

        async buyProduct(size){
            if(this.product.has_sizes && !size){
                this.error = 'Выберите размер';
                setTimeout(this.clearError, 5000);

                return;
            }

            try{
                const {data: response} = await this.$axios.post('api/v1/product/buy', {
                    id: this.product.id, count: 1,
                    size: size ? size.id : null,
                    sizeName: size ? size.size : null
                });
                this.success = true;
                this.error = null;
                this.showSizes = false;
                this.setBasketCount(response.count);
                if (this.$ecommerce) {
                    this.$ecommerce.add(this.product, {
                        quantity: 1,
                        size,
                    });
                }
                setTimeout(this.clearSuccess, 5000);
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = 'Ошибка';
                } else {
                    this.error = 'Ошибка';
                }
                setTimeout(this.clearError, 5000);
            }
        },
        clearError(){
            this.error = null;
            this.success = false;
            this.process = false;
        },
        clearSuccess(){
            this.size = null;
            this.error = null;
            this.success = false;
            this.process = false;
        },
    },
}
